/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateExerciseToolDto
 */
export interface CreateExerciseToolDto {

    /**
     * @type {string}
     * @memberof CreateExerciseToolDto
     */
    type: CreateExerciseToolDtoTypeEnum;

    /**
     * @type {boolean}
     * @memberof CreateExerciseToolDto
     */
    asset: boolean;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateExerciseToolDto
     */
    exercise: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateExerciseToolDto
     */
    client: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseToolDtoTypeEnum {
    CHAIR = 'CHAIR',
    MAT = 'MAT',
    TABLE = 'TABLE',
    BALL = 'BALL',
    BOX = 'BOX',
    ROD = 'ROD',
    MINIROD = 'MINI_ROD',
    WEIGHT = 'WEIGHT'
}

